import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShutterstockComponent } from './simple-icons-shutterstock.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShutterstockComponent ],
    exports:      [ SimpleIconsShutterstockComponent ],
    bootstrap:    []
})
export class SimpleIconsShutterstockModule {}
